<template>
    <div id="cloudInfo" v-loading="loading">
        <!-- PC端内容 -->
        <div class="page flex-col" v-if="!isMobile">
            <div class="box_1 flex-col">
                <div class="p_img">
                    <a href="javascript:;">
                        <img src="../../assets/client/banner_stdn.jpg" alt="生态大脑" title="生态大脑">
                    </a>
                </div>
                <div class="p_info">
                    <div>
                        <h2 class="text-white p_btitle">生态大脑</h2>
                        <h6 class="text-white p_subtitle">SAILHERO&nbsp;ENVIRONMENTAL&nbsp;PROTECTION</h6>
                    </div>
                </div>
            </div>
            <div class="box_3 flex-col justify-end">
                <div class="group_2 flex-row">
                    <span class="text_13">当前位置：首页&nbsp;&gt;&nbsp;{{ cloudInfo.cloud_type_name	}}</span>
                    <div class="text-wrapper_6_be">
                        <transition  name="slide">
                            <div class="text-wrapper_1 flex-col" v-if="telshow">
                                <span class="text_14">4001-300-137</span>
                            </div>
                        </transition>
                    </div>
                    <div class="box_8_1">
                        <div class="box_4 flex-row" style="cursor:pointer;" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
                            <div class="image-text_1 flex-col justify-between">
                                <img class="label_1" referrerpolicy="no-referrer" src="../../assets/client/icon_lxfs.png" />
                                <span class="text-group_1">业务咨询</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="group_3 flex-row justify-between">
                    <span class="text_15">{{cloudInfo.system_name}}</span>
                </div>
                <div class="group_5 flex-col"></div>
                <div class="group_6 flex-row justify-between">
                    <div class="group_7 flex-col"></div>
                    <span class="text_16">简介</span>
                </div>
                <div class="text-wrapper_2" v-html="cloudInfo.system_content"></div>
                <div class="text-wrapper_3 flex-col"></div>
            </div>
        </div>

        <!-- 移动端内容 -->
        <div class="mobile-cloudinfo-container" v-if="isMobile">
            <!-- Banner区域 -->
            <div class="mobile-cloudinfo-banner">
                <img class="mobile-cloudinfo-banner__image" src="../../assets/client/banner_stdn.jpg" alt="云服务详情" />
                <div class="mobile-cloudinfo-banner__overlay"></div>
                <div class="mobile-cloudinfo-banner__content">
                    <h1 class="mobile-cloudinfo-banner__title">{{ cloudInfo.cloud_type_name || '生态大脑' }}</h1>
                    <p class="mobile-cloudinfo-banner__subtitle">SAILHERO ENVIRONMENTAL PROTECTION</p>
                </div>
            </div>

            <!-- 面包屑导航 -->
            <div class="mobile-cloudinfo-breadcrumb">
                <p class="mobile-cloudinfo-breadcrumb__text">
                    首页 > <span class="mobile-cloudinfo-breadcrumb__current">{{ cloudInfo.cloud_type_name || '云服务' }}</span>
                </p>
            </div>

            <!-- 系统名称展示 -->
            <div class="mobile-cloudinfo-title">
                <h2 class="mobile-cloudinfo-title__text">{{ cloudInfo.system_name }}</h2>
            </div>

            <!-- 简介内容区域 -->
            <div class="mobile-cloudinfo-content">
                <div class="mobile-cloudinfo-content__header">
                    <div class="mobile-cloudinfo-content__header-bar"></div>
                    <h3 class="mobile-cloudinfo-content__header-title">简介</h3>
                </div>
                <div class="mobile-cloudinfo-content__body" v-html="cloudInfo.system_content"></div>
            </div>
        </div>
    </div>
</template>
<script>
import "../../assets/client/cloudInfo.css";
import "../../assets/client/cloudInfo-mobile.css";
export default{
    data() {
        return {
            cloudInfo: { system_name: "", system_content: "" },
            loading:false,
            telshow:false,
            isMobile: false,
            lastDeviceType: null,
        }
    },
    methods: {
        getData() {
            let that = this;
            if (that.$route.query.id) {
                that.loading = true;
                that.cloudInfo = { system_name: "", system_content: "" };
                that.$api.post("/Client/getHomeCloudDataById", { id: that.$route.query.id },
                    function (res) {
                        if (res.code === "200") {
                            that.cloudInfo = res.data;
                        }
                        that.loading = false;
                    },
                    function (res) {
                        that.loading = false;
                        //that.$message.error("服务器异常，删除出错");
                    }
                );
            }
        },
        resizeImage(event) {
            const img = event.target;
            const width = img.naturalWidth;
            const height = img.naturalHeight;
            img.style.width = `${width}px`;
            img.style.height = `${height}px`;
        },
        handleMouseEnter(){
                let that = this;
                that.telshow = true;
        },
        handleMouseLeave(){
            let that = this;
            that.telshow = false;
        },
        checkMobile() {
            const wasMobile = this.isMobile;
            this.isMobile = window.innerWidth <= 768;
            
            // 检测设备类型变化
            const currentDeviceType = this.isMobile ? 'mobile' : 'pc';
            if (this.lastDeviceType && this.lastDeviceType !== currentDeviceType) {
                // 设备类型发生了变化，需要重新加载数据
                this.getData();
            }
            this.lastDeviceType = currentDeviceType;
        }
    },
    mounted() {
        this.$parent.$refs.menu.setActiveIndex("1");
        this.checkMobile();
        window.addEventListener('resize', this.checkMobile);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkMobile);
    },
    watch: {
        '$route.query.id': {
            handler: function (to, from) {
                this.getData();
            },
            immediate: true // 立即触发
        }
    }
}
</script>
<style scoped>
        .slide-enter-active, .slide-leave-active {
        transition: transform 0.5s;
    }

    .slide-enter, .slide-leave-to /* .slide-leave-active for <2.1.8 */ {
        transform: translateX(22.53vw);
    }


    .p_img img {
        height: 100%;
        width: 100%;
        object-fit: cover;
        animation: bannerimg 2s;
    }

    .p_info .p_btitle {
        animation: puBanner 1s;
        color: #FFF;
        font-size: 59px;
        font-weight: 900;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .p_info .p_subtitle {
        animation: puBanner 1s;
        color: #FFF;
        font-size: 1.458333vw;
        font-weight: 400;
        position: relative;
        bottom: 3.125vw;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        letter-spacing: 0.05625vw;
    }

    .p_info {
        width: 100%;
        max-width: 1600px;
        padding: 0 5px;
        position: absolute;
        left: 257px;
        top: 120px;
        letter-spacing: 3px;
        z-index: 9;
    }

    @keyframes puBanner {
        from {
            transform: translateY(200px);
            opacity: 0
        }

        to {
            transform: translateY(0);
            opacity: 1
        }
    }

    @keyframes bannerimg {
        from {
            transform: scale(1.15)
        }

        to {
            transform: scale(1);
        }
    }
</style>
